"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { format } from "date-fns/format";
import { cn } from "../../../utils/index.js";
import { CdnIcon } from "../../CdnIcon/index.js";
import { Span } from "../../Text/Span.js";
import { calendarVariants } from "../Calendar/Calendar.variants.js";
function HolidayList({ holidays, slots }) {
    if (!holidays.length) return null;
    const { holidayRoot, holidayListItem } = calendarVariants();
    const holidayRootClasses = cn(holidayRoot(), slots?.holidayRoot);
    return /*#__PURE__*/ jsx("div", {
        className: holidayRootClasses,
        children: holidays.map((holiday)=>/*#__PURE__*/ jsxs(Span, {
                className: holidayListItem(),
                children: [
                    /*#__PURE__*/ jsx(CdnIcon, {
                        "aria-hidden": true,
                        iconName: "event",
                        size: "16",
                        className: "shrink-0 font-bold"
                    }),
                    /*#__PURE__*/ jsx(Span, {
                        textStyle: "body3",
                        palette: "neutral",
                        shade: "10",
                        bold: true,
                        className: "min-w-10 shrink-0",
                        children: format(holiday.date, 'MMM d')
                    }),
                    /*#__PURE__*/ jsx(Span, {
                        textStyle: "body3",
                        palette: "neutral",
                        shade: "10",
                        className: "min-w-0 break-words",
                        children: holiday.name
                    })
                ]
            }, holiday.dateKey))
    });
}
export { HolidayList };
